import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row g-3" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = { class: "col-md-6" }
const _hoisted_4 = {
  key: 0,
  class: "alert alert-danger mt-3 mb-0"
}
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalConsulte = _resolveComponent("ModalConsulte")!

  return (_openBlock(), _createBlock(_component_ModalConsulte, {
    ref: "modalRef",
    "hide-footer": false,
    modalWidth: "600px !important"
  }, {
    header: _withCtx(() => [...(_cache[5] || (_cache[5] = [
      _createElementVNode("h4", { class: "modal-title" }, "Renovação de Empréstimo", -1)
    ]))]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[6] || (_cache[6] = _createElementVNode("label", {
            class: "form-label",
            for: "campo-dataEmprestimo-58bb"
          }, "Data de Renovação", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.dataEmprestimo) = $event)),
            type: "date",
            class: "form-control",
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.recalcularVencimento && _ctx.recalcularVencimento(...args))),
            id: "campo-dataEmprestimo-58bb"
          }, null, 544), [
            [_vModelText, _ctx.form.dataEmprestimo]
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[7] || (_cache[7] = _createElementVNode("label", {
            class: "form-label",
            for: "campo-dataVencimento-58bb"
          }, "Data de Vencimento", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.dataVencimento) = $event)),
            type: "date",
            class: "form-control",
            readonly: "",
            id: "campo-dataVencimento-58bb"
          }, null, 512), [
            [_vModelText, _ctx.form.dataVencimento]
          ])
        ])
      ]),
      (_ctx.mensagemErro)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.mensagemErro), 1))
        : _createCommentVNode("", true)
    ]),
    actions: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-light",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      }, "Cancelar"),
      (_ctx.permissaoTela.alterar)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-primary",
            disabled: _ctx.salvando,
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.salvar && _ctx.salvar(...args)))
          }, _toDisplayString(_ctx.salvando ? "Salvando..." : "OK"), 9, _hoisted_5))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}